import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  FormInputComponent,
  InputComponentConfig,
  SharedModule,
} from '@vendure/admin-ui/core';

/**
 * This is a regular text input but converts the value to an integer.
 * It was created to support the "existingFlowtechAccountNumber" custom field
 * on Customer.
 */
@Component({
  selector: 'ft-integer-text-form-input',
  imports: [SharedModule],
  template: `<div class="form-grid">
    <input
      type="text"
      pattern="[0-9]*"
      [readonly]="readonly"
      [formControl]="textControl"
      (input)="onTextChange()"
    />
  </div>`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntegerTextFormInputComponent
  implements OnInit, FormInputComponent
{
  static readonly id = 'integer-text-form-input';
  @Input() readonly: boolean;
  formControl: UntypedFormControl;
  config: InputComponentConfig;
  textControl: UntypedFormControl = new UntypedFormControl('');

  ngOnInit(): void {
    this.textControl.patchValue(this.formControl.value?.toString() || '');
  }

  onTextChange(): void {
    const textValue = this.textControl.value;
    const intValue = parseInt(textValue, 10);
    this.formControl.markAsDirty();
    this.formControl.patchValue(isNaN(intValue) ? null : intValue);
  }
}
